module.exports = __webpack_public_path__ + "static/img/1024.a857acc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1024.jpg
// module id = 206
// module chunks = 0